// extracted by mini-css-extract-plugin
module.exports = {"scrollBar":"style_scrollBar__1OU_G"};